module.exports = "/_next/static/media/2bd661e53810a5d88e5032fc7a76f4d6.svg";